import React, { useEffect, useState } from "react";

import Loading from "../../atoms/loading/loading";
import BookSlider from "../book-slider/bookSlider";
import PodcastsSlider from "../podcasts-slider/podcastsSlider";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { getFilteredResults } from "../../../services/filter";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./lastAddedBooks.scss";

const LastAddedBooks = (props: ReferenciaContenido) => {
  const { tituloGeneral, referenciaTabsContenido, nombreCategoria } = props;
  const [tabSelected, setTabSelected] = useState(0);
  const [elements, setElements] = useState<any>([]);
  const { isBrowser, document } = useBrowserMode();

  useEffect(() => {
    if (tabSelected > -1) {
      setElements([]);
      getBooks();
    }
  }, [tabSelected]);

  const getBooks = async () => {
    const infoElement =
      referenciaTabsContenido[tabSelected].referenciaContenido[0];
    const request = await getFilteredResults(
      "",
      infoElement.tipoLibro,
      "15",
      infoElement.autoresArticulo ? infoElement.autoresArticulo.join("/") : "",
      infoElement.etiquetasArticulo
        ? infoElement.etiquetasArticulo.join("/")
        : "",
      "CREATION_DATE",
      "",
      0
    );
    let auxElements = elements;
    auxElements = request?.data.data.filter || [];
    auxElements.push("Ver todo")
    setElements(auxElements);
  };

  const handleTabs = (index: number) => {
    const elementSelected: any = document.getElementsByClassName(
      "m-last-added__titles__option"
    )[index];
    if (isBrowser)
      document.getElementById("m-last-added__titles").scrollLeft =
        elementSelected.offsetLeft - 15;
    setTabSelected(index);
  };

  return (
    <section className="m-last-added">
      <h2 className="m-last-added__title-mobile">{tituloGeneral}</h2>
      <div className="m-last-added__titles" id="m-last-added__titles">
        {referenciaTabsContenido.slice(0, 2).map((tab: any, idx: number) => (
          <h3
            key={idx}
            className={`m-last-added__titles__option ${
              tabSelected === idx
                ? "m-last-added__titles__option--selected"
                : ""
            } gtm${normalizeTwoWords(
              nombreCategoria
            )}UltimoAnadido${normalizeTwoWords(tab.nombreTab)}`}
            onClick={() => handleTabs(idx)}
          >
            {tab.nombreTab}
          </h3>
        ))}
        <h2 className="m-last-added__titles__title">{tituloGeneral}</h2>
        {referenciaTabsContenido.slice(2, 4).map((tab: any, idx: number) => (
          <h3
            key={idx + 2}
            className={`m-last-added__titles__option ${
              tabSelected === idx + 2
                ? "m-last-added__titles__option--selected"
                : ""
            } gtm${normalizeTwoWords(
              nombreCategoria
            )}UltimoAnadido${normalizeTwoWords(tab.nombreTab)}`}
            onClick={() => handleTabs(idx + 2)}
          >
            {tab.nombreTab}
          </h3>
        ))}
      </div>
      <div className="m-last-added__carousel">
        {elements.length > 0 ? (
          elements[0].tipoContenido.indexOf("podcast") !== -1 ? (
            <PodcastsSlider
              podcasts={elements}
              gtmClass={`${normalizeTwoWords(
                nombreCategoria
              )}UltimoAnadido${normalizeTwoWords(
                referenciaTabsContenido[tabSelected].nombreTab
              )}`}
              tab={tabSelected}
            />
          ) : (
            <BookSlider
              books={elements}
              gtmClass={`${normalizeTwoWords(
                nombreCategoria
              )}UltimoAnadido${normalizeTwoWords(
                referenciaTabsContenido[tabSelected].nombreTab
              )}`}
              tab={tabSelected}
            />
          )
        ) : (
          <Loading />
        )}
      </div>
    </section>
  );
};

export default LastAddedBooks;
